import { useEffect, useState } from "react";
import {
  DKLabel,
  DKLine,
  showLoader,
  removeLoader,
  showToast,
  TOAST_TYPE,
  DKRadioButton,
  DKInput,
  DKButton,
  isValidEmail,
} from "deskera-ui-library";
import Utility, { deepClone } from "../../utility/Utility";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import {
  CONTRACTOR_FIELD_MAP,
  initialCompensationFormField,
  initialContractorDetailsFormField,
  initialContractorPaymentDetails,
  contractorDetailDefaultValues,
} from "./Contractor";
import {getQueryParam, getSelectedIdFromObject, getTenantCountryCode, isMYCompliance, isUSCompliance, trimValue} from "../../managers/common/CommonUtil"
import { useDispatch, useSelector } from "react-redux";
import { deleteEmployeeDetails, fetchBankDetails, fetchEmployeeDetails, selectBankDetails, selectEmployeeData } from "../../Redux/Slices/EmployeeListSlice";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import Address, { ADDRESS_MODULE, getAddressFields } from "../common/Address";
import { ACCOUNT_NUMBER, COLUMN_CODES, CONSTANTS, COUNTRY_CODE, INPUT_TYPE, ROUTING_REGEX, USRoutingNumberRegex } from "../../constants/Constant";
import DataGridUtility from "../../utility/DataGridUtility";
import UserService from "../../services/UserService";
import {
  IFSC_PATTERN,
  SSN_PATTERN,
  UPI_PATTERN,
  EIN_PATTERN,
  ROUTING_NUMBER_REGEX,
} from "../../constants/RegexConstants";
import { AccountTypes, AccountTypesUS, SGPaymentMethods, USPaymentMethods } from "../add-employee/steps/Employee";
import EmployeeListService from "../../services/EmployeeListService";
import Table from "../../services/table";
import TenantManager from "../../managers/TenantManager";
import { COMPLIANCE_COUNTRIES, COUNTRY } from "../../constants/CountryConstant";
import { ADMIN } from "../../managers/common/RouteAuth";
import PermissionUtils, { ACTION } from "../user-permissions/PermissionUtils";

const AddContractor = (props) => {

    let [userId, setUserId] = useState(getQueryParam(props.location, "id"))
    const isContracor = TenantService.get(TENANT.IS_CONTRACTOR)
    const isEdit = (getQueryParam(props.location, "isEdit") === "true" || isContracor) ;
    const [countryCode, setCountryCode] = useState("-1");
    const [defaultValues, setDefaultValues] = useState(deepClone(contractorDetailDefaultValues));
    let [detailsInitials, setDetailsInitials] = useState(deepClone(initialContractorDetailsFormField));
    let [detailsFormfields, setDetailsFormFields] = useState(deepClone(detailsInitials));
    let [contactFormfields, setContactFormFields] = useState(null);
    const [compensationInitials, setCompensationInitials] = useState(
      deepClone(initialCompensationFormField)
    );
    let [compensationFormfields, setCompensationFormFields] =
      useState(deepClone(compensationInitials));
    const [paymentInitials, setPaymentInitials] = useState(
      deepClone(initialContractorPaymentDetails)
    );
    let [paymentFormfields, setPaymentFormFields] = useState(paymentInitials);
    const [country, setCountry] = useState("");
    const tenatBankDetails = useSelector(selectBankDetails);

    //React Hooks
    const dispatch = useDispatch()
    const contractorDetails = useSelector(selectEmployeeData);
    const [count, updateCount] = useState(1);

    const forceUpdate = () => {
      updateCount(count + 1);
    }

    useEffect(() => {
        RouteManager.setPresenter({ props });
        buildForm();
        if (getTenantCountryCode() === COUNTRY.SG || getTenantCountryCode() === COUNTRY.MY ) {
            loadTenantBankDetails(getTenantCountryCode());
        }
        if (!isEdit) {
          setCountryCode(TenantService.get(TENANT.COUNTRY_CODE));
        }
        if(isEdit && !Utility.isEmpty(userId)) {
          showLoader();
          loadContractorDetails(userId);
        }
        if(isEdit && isContracor) {
          showLoader();
          let userID = TenantService.get(TENANT.USER_ID)
          loadContractorDetails(userID);
          setUserId(userID)
        }
    },[]);

    useEffect(() => {
      if (
        !Utility.isEmpty(userId) &&
        !Utility.isEmpty(contractorDetails) &&
        contractorDetails.user
      ) {
        updateContractorDetails();
        if (contractorDetails.user.address.country) {
          setCountryCode(contractorDetails.user.address.country);
          updateAddressData();
        }
         else {
          setCountryCode(TenantService.get(TENANT.COUNTRY_CODE));
        }
        removeLoader();
      }
    }, [contractorDetails]);

    useEffect(() => {
        let tenantData = TenantService.getData();
        setCountry(tenantData[TENANT.COUNTRY_CODE]);
        const { tenant } = TenantManager.getPeopleTenantData();
        switch (tenantData[TENANT.COUNTRY_CODE]) {
          case COUNTRY_CODE.US:
            let paymentDetails = paymentInitials;
            const alteredOptionsUS = [
              {columnCode: "paymentMethod", options: USPaymentMethods, defaultOptions: USPaymentMethods },
              {columnCode: "accountType", options: AccountTypesUS, defaultOptions: AccountTypesUS},
              {columnCode: "ifsc", uiVisible: false, required : false},
              {columnCode:"routingNumber", required: true, errMsg: "Branch Code is required"},
              {columnCode: "bank", uiVisible: false, required : false},
            ];
            paymentDetails = EmployeeListService.getAlteredConfigDetails(
              paymentDetails,
              alteredOptionsUS,
              false,
              {},{}
            );
            setPaymentInitials(paymentDetails);
            break;
            case COUNTRY_CODE.SG:
            let paymentDetailsSG = paymentInitials;
            const bankAccounts = EmployeeListService.getBankAccounts(tenatBankDetails);
            const alteredOptionsSG = [
              {columnCode: "paymentMethod", options: SGPaymentMethods, defaultOptions: SGPaymentMethods },
              {columnCode: "bank", options: bankAccounts, defaultOptions: bankAccounts},
              {columnCode: "ifsc", uiVisible: false, required : false},
              {columnCode:"routingNumber", name: "Branch Code", required: true, errMsg: "Branch Code is required"},
              {columnCode: "accountType", uiVisible: false, required : false},
              { columnCode: "accountNumber", name : "Account Number" }
            ];
            paymentDetailsSG = EmployeeListService.getAlteredConfigDetails(paymentDetailsSG, alteredOptionsSG, false, {}, {});
            setPaymentInitials(paymentDetailsSG);
            break;
            case COUNTRY.MY:
            let paymentDetailsMY = paymentInitials;
            const bankAccountsMY = EmployeeListService.getBankAccounts(tenatBankDetails);
            const alteredOptionsMY = [
              { columnCode: "paymentMethod", options: USPaymentMethods, defaultOptions: USPaymentMethods },
              {columnCode: "bank", options: bankAccountsMY, defaultOptions: bankAccountsMY},
              {columnCode: "ifsc", uiVisible: false, required : false},
              {columnCode:"routingNumber", name: "Branch Code", required: true, errMsg: "Branch Code is required"},
              {columnCode: "accountType", uiVisible: false, required : false},
              { columnCode: "accountNumber", name : "Account Number" }
            ];
            paymentDetailsMY = EmployeeListService.getAlteredConfigDetails(paymentDetailsMY, alteredOptionsMY, false, {}, {});
            setPaymentInitials(paymentDetailsMY);
            break;
          case COUNTRY.IN:
            let paymentDetailsIN = paymentInitials;
            const alteredOptionsIN = [
              {columnCode: "bank", uiVisible: false, required : false}
            ];
            paymentDetailsIN = EmployeeListService.getAlteredConfigDetails(paymentDetailsIN, alteredOptionsIN, false, {}, {});
            setPaymentInitials(paymentDetailsIN);
          default:
            break;
        }
      updateDefaultValue();
    }, [
      detailsFormfields,
      contactFormfields,
      paymentFormfields,
      compensationFormfields,
      tenatBankDetails,
      paymentInitials
    ]);

    const loadContractorDetails = async (userId) => {
      try {
        const config = {
          ...EmployeeListService.apiConfig,
          getComponents: true,
          getCompliance: true,
          getBenefits: true,
          customFieldModule: "employee",
        };
        EmployeeListService.apiConfig = config;
        await dispatch(fetchEmployeeDetails(userId));
      } catch (err) {
        removeLoader();
      }
    };

    const loadTenantBankDetails = async (countryCode) => {
        try {
          await dispatch(fetchBankDetails(countryCode));
        } catch (err) {
          console.error("Error loading custom fields data: ", err);
        }
    }

    const updateContractorDetails = () => {
      let userDetails = contractorDetails.user;
      let bankAccounts = tenatBankDetails?.banksDetails ? EmployeeListService.getBankAccounts(tenatBankDetails) : [];
      EmployeeListService.assignContractorDetails(
        defaultValues,
        userDetails,
        bankAccounts
      );
      let paymentMethod = defaultValues["paymentMethod"];
      updateColumConfigForPaymentMethod(paymentMethod);
      let period = defaultValues["compensationPeriod"];
      updateCompensationField(period);
      let type = defaultValues["contractorType"];
      updateUniqueIdentificationField(type)
      buildForm();
    }

    const updateDefaultValue = () => {
      let data = {
        columnConfig: {
          detailsConfig: detailsFormfields,
          compensationConfig: compensationFormfields,
          paymentConfig: paymentInitials,
          contactConfig: contactFormfields
        },
        defaults: defaultValues,
      };
      let defaults = deepClone(defaultValues);
      setDefaultValues(defaults);
    };

    useEffect(() => {
      updateAddressData()
    }, [countryCode]);

    const updateAddressData = () => {
      if (countryCode !== "-1") {
        const contactFormfields = getAddressFields(
          countryCode,
          ADDRESS_MODULE.EMPLOYEE_DETAILS
        );

        if (isEdit && contractorDetails?.user?.address) {
          const address = contractorDetails.user.address;

          contactFormfields.forEach((field) => {
            if (field.type === INPUT_TYPE.DROPDOWN && field.id === "country") {
              let value = !Utility.isEmpty(address[field.id])
                ? address[field.id]
                : countryCode;
              field.value = getSelectLabel(value, field.options);
            } else if (field.type === INPUT_TYPE.DROPDOWN) {
              field.value = getSelectLabel(address[field.id], field.options);
            } else {
              field.value = address[field.id];
            }
          });
        } else {
          contactFormfields.forEach((field) => {
            if (field.id === "country") {
              field.value = getSelectLabel(countryCode, field.options);
            }
          });
        }

        setContactFormFields(contactFormfields);
        buildForm();
      }
    }

    const getSelectLabel = (v, o) => {
      let value = v;
      const index = o.findIndex((i) => i.value === v);
      if (index !== -1) {
        value = o[index].label;
      }
      return value;
    };

    const buildForm = () => {
        let visibleDetailsFields = countryWiseSectionFields(
          countryCode,
          detailsInitials,
          detailsFormfields,
          "detailsFields"
        );
        detailsFormfields = visibleDetailsFields.filter((x) => x.uiVisible);
        let contractorContactFields = DataGridUtility.getFormElements(
          detailsFormfields,
          defaultValues,
          true
        );
        setDetailsFormFields(contractorContactFields);

        let visiblePaymentFields = countryWiseSectionFields(
          countryCode,
          paymentInitials,
          paymentFormfields,
          "paymentFields"
        );
        paymentFormfields = visiblePaymentFields.filter((x) => x.uiVisible);
        let contractorPaymentFields = DataGridUtility.getFormElements(
          paymentFormfields,
          defaultValues,
          true
        );
        setPaymentFormFields(contractorPaymentFields);

        let visibleCompensationFields = countryWiseSectionFields(
          countryCode,
          compensationInitials,
          compensationFormfields,
          "compensationFields"
        );
        compensationFormfields = visibleCompensationFields.filter((x) => x.uiVisible);
        let contractorCompensationFields = DataGridUtility.getFormElements(
          compensationFormfields,
          defaultValues,
          true
        );
        setCompensationFormFields(contractorCompensationFields);


    }

    const countryWiseSectionFields = (countryCode,sectionInitialFields, sectionFields, sections) => {
        const fields = [];
        const visibleFields = COMPLIANCE_COUNTRIES.includes(countryCode) ? CONTRACTOR_FIELD_MAP[countryCode] : CONTRACTOR_FIELD_MAP["DEFAULT"];
        if(visibleFields && visibleFields[sections] && visibleFields[sections].length > 0) {
            visibleFields[sections].forEach((field) => {
              let inputField = sectionInitialFields.find((x) => x.columnCode === field);
              let maniplatedField = sectionFields.find(
                (x) => x.columnCode === field
              );
              if (maniplatedField && sections != "paymentFields") {
                inputField["hasError"] = maniplatedField.hasError ? maniplatedField.hasError : false;
                if (maniplatedField.hasError) {
                  inputField["errMsg"] = maniplatedField.errMsg;
                }
              }
              switch(inputField.columnCode) {
                case COLUMN_CODES.PAYMENT_METHOD:
                  if(countryCode != COUNTRY_CODE.INDIA) {
                    let options = inputField.options;
                    if (options && options.length > 0) {
                      let index = options.findIndex(x => x.id === "upi");
                      if(index != -1) {
                        options.splice(index,1)
                      }
                    }
                  }
              }
              if (inputField) {
                fields.push(inputField);
              }
            });
            return fields;
        } else {
            return sectionInitialFields;
        }
    }

    const onContractorTypeChange = (selectedValue, fieldId) => {
        defaultValues[fieldId] = selectedValue;
        switch(fieldId) {
            case "compensationPeriod" :
                updateCompensationField(selectedValue);
                buildForm();
                break;
            case "contractorType":
                updateUniqueIdentificationField(selectedValue);
                buildForm();
                break;
            default:
              let values = deepClone(defaultValues);
              setDefaultValues(values);
        }
    }

    const updateCompensationField = (selectedValue) => {
      if (selectedValue === "hourly") {
        compensationInitials[0].name = "Hourly Wages Amount";
        compensationInitials[0].errMsg = "Enter a valid Hourly Wages";
      } else if (selectedValue === "fixed") {
        compensationInitials[0].name = "Fixed Amount";
        compensationInitials[0].errMsg = "Enter a valid Fixed Amount";
      }
    };

    const updateUniqueIdentificationField = (selectedValue) => {
        if (selectedValue === "INDIVIDUAL") {
          let ssnColumn = detailsInitials.find((x) => x.columnCode === "socialSecurityNumber");
          if (ssnColumn) {
              ssnColumn.uiVisible = true;
          }
          let identificationColumn = detailsInitials.find((x) => x.columnCode === "employerIdentificationNumber");
          if (identificationColumn) {
              identificationColumn.uiVisible = false;
          }
          let displayNameColumn = detailsInitials.find((x) => x.columnCode === "displayName");
          if (displayNameColumn) {
            displayNameColumn.name = "Display Name";
            displayNameColumn.errMsg = "Enter a valid Display Name"
          }
        } else if (selectedValue === "BUSINESS") {
          let ssnColumn = detailsInitials.find((x) => x.columnCode === "socialSecurityNumber");
          if (ssnColumn) {
            ssnColumn.uiVisible = false;
          }
          let identificationColumn = detailsInitials.find((x) => x.columnCode === "employerIdentificationNumber");
          if (identificationColumn) {
            identificationColumn.uiVisible = true;
          }
          let displayNameColumn = detailsInitials.find((x) => x.columnCode === "displayName");
          if (displayNameColumn) {
            displayNameColumn.name = "Business Name";
            displayNameColumn.errMsg = "Enter a valid Business Name"
          }
        }
    }

    const onChange = (value, index, object, sectionName) => {
        if (value && value === " ") {
          value = value.trim();
        }
        if (sectionName === "CONTRACTOR_DETAILS") {
            let columnConfig = deepClone(detailsFormfields);
            if (Utility.isEmpty(value) && object.required) {
              columnConfig[index].hasError = true;
            } else {
              columnConfig[index].hasError = false;
            }
            switch (object.columnCode) {
              case "emailId":
                columnConfig[index].hasError =
                  value.trim() != "" && isValidEmail(value) ? false : true;
                columnConfig[index].errMsg = "Enter a valid Email";
                if (!Utility.isEmpty(value) && isValidEmail(value)) {
                  setTimeout(() => {
                    let params = {
                      emailId: encodeURIComponent(value),
                      userId: userId,
                    };
                    UserService.isEmailDuplicateContractor(params).then((response) => {
                      if (response && response["isdupliacateEmail"]) {
                        columnConfig = deepClone(detailsFormfields);
                        columnConfig[index].errMsg =
                          "This email has already been taken.";
                        columnConfig[index].hasError = true;
                        setDetailsFormFields(columnConfig);
                      }
                    });
                  }, 1000);
                }
                break;
              case "socialSecurityNumber":
                if (!Utility.isEmpty(value)) {
                  const regexSSN = new RegExp(SSN_PATTERN);
                  columnConfig[index].hasError = !regexSSN.test(value);
                  if (columnConfig[index].hasError) {
                    columnConfig[index].hasError = true;
                    columnConfig[index].errMsg =
                      "Enter a valid SSN (Ex: 123-12-1234)";
                  } else {
                    columnConfig[index].hasError = false;
                  }
                } else {
                  columnConfig[index].hasError = true;
                }
                defaultValues[object.id] = value;
                setDetailsFormFields(columnConfig);
                break;
              case "employerIdentificationNumber":
                if (!Utility.isEmpty(value)) {
                  const regexSSN = new RegExp(EIN_PATTERN);
                  columnConfig[index].hasError = !regexSSN.test(value);
                  if (columnConfig[index].hasError) {
                    columnConfig[index].hasError = true;
                    columnConfig[index].errMsg =
                      "Enter a valid EIN (Ex: 01-1234567)";
                  } else {
                    columnConfig[index].hasError = false;
                  }
                } else {
                  columnConfig[index].hasError = true;
                }
                defaultValues[object.id] = value;
                setDetailsFormFields(columnConfig);
                break;
            }
            defaultValues[object.id] = value;
            setDetailsFormFields(columnConfig);
        } else if (sectionName === "COMPENSATION_DETAILS") {
            let columnConfig = deepClone(compensationFormfields);
            if (Utility.isEmpty(value) && object.required) {
              columnConfig[index].hasError = true;
            } else {
              columnConfig[index].hasError = false;
            }
            defaultValues[object.id] = value;
            setCompensationFormFields(columnConfig);
        } else if (sectionName === "PAYMENT_DETAILS") {
          let columnConfig = deepClone(paymentFormfields);
          if (object.id === "paymentMethod") {
            defaultValues[object.id] = value;
            updateColumConfigForPaymentMethod(value);
            buildForm();
          } else if (Utility.isEmpty(value) && object.required) {
            columnConfig[index].hasError = true;
            columnConfig[index].errMsg = `Enter a valid ${object.name}`;
            defaultValues[object.id] = value;
            setPaymentFormFields(columnConfig);
          } else {
            switch (object.id) {
              case COLUMN_CODES.IFSC_CODE:
                const regexIFSC = new RegExp(IFSC_PATTERN);
                columnConfig[index].hasError = !regexIFSC.test(value);
                if (columnConfig[index].hasError) {
                  columnConfig[index].errMsg = CONSTANTS.INVALID_IFSC;
                } else {
                  columnConfig[index].errMsg = `Enter a valid ${object.name}`;
                }
                break;
              case COLUMN_CODES.ACCOUNT_NUMBER:
                let bank = (defaultValues.bank && defaultValues.bank.key) ?  defaultValues.bank.key : defaultValues.bank
                checkForAccountNumberIsValid(columnConfig, index, country, value, bank, object)
                break;
              case COLUMN_CODES.UPI_ID:
                const regexUPI = new RegExp(UPI_PATTERN);
                columnConfig[index].hasError = !regexUPI.test(value);
                if (columnConfig[index].hasError) {
                  columnConfig[index].errMsg = CONSTANTS.INVALID_UPI;
                } else {
                  columnConfig[index].errMsg = `Enter a valid ${object.name}`;
                }
                break;
              case COLUMN_CODES.ROUTING_NUMBER:
                let bankKey = isMYCompliance()? defaultValues['bank'].key:null
                checkRoutingNumberIsValid(columnConfig, index, country, value,bankKey , object);
                break;
              case COLUMN_CODES.BANK:
                  if(value.key) {
                    let routingNoIndex = columnConfig.findIndex(col=>col.columnCode=='routingNumber')
                    let routingObj = columnConfig[routingNoIndex]
                    checkRoutingNumberIsValid(columnConfig, routingNoIndex, country, defaultValues['routingNumber'], value.key, routingObj);
                  
                    let accountNoIndex = columnConfig.findIndex(col=>col.columnCode=='accountNumber')
                    let accountObj = columnConfig[accountNoIndex]
                    checkForAccountNumberIsValid(columnConfig,accountNoIndex,country,defaultValues['accountNumber'],value.key,accountObj)
                  }
                  break;
              default:
                columnConfig[index].hasError = false;
            }
            defaultValues[object.id] = value;
            setPaymentFormFields(columnConfig);
          }
        }
    };

    const checkRoutingNumberIsValid = (columnConfig, index, country, value, bankKey, object) => {
        let regexStr = ROUTING_REGEX[country]?.regex
        if (isMYCompliance() && ROUTING_NUMBER_REGEX[country] && ROUTING_NUMBER_REGEX[country][bankKey]) {
          regexStr = ROUTING_NUMBER_REGEX[country][bankKey].regex 
          columnConfig[index].errMsg = `${object.name} should be ${ROUTING_NUMBER_REGEX[country][bankKey].errorMsg}` 
        }
        const regex = new RegExp(regexStr);
        const routingRegexValue = !regex.test(value);
        if (!Utility.isEmpty(value) && routingRegexValue) {
          columnConfig[index].hasError = routingRegexValue;
          columnConfig[index].errMsg = ROUTING_REGEX[country]?.error || columnConfig[index].errMsg;;
        } else {
          columnConfig[index].hasError = false;
          columnConfig[index].errMsg = `Enter a valid ${object.name}`;
        }
      }
      const checkForAccountNumberIsValid = (columnConfig,index,country,value,bankKey,object) => {
        if (columnConfig[index].required && !Utility.isEmpty(value)) {
          let validationConfig = isMYCompliance() ? ACCOUNT_NUMBER[country][bankKey]: ACCOUNT_NUMBER[country];
          if (validationConfig?.isRegex) {
            const regexAccountNumber = new RegExp(validationConfig.regexPattern);
            const accountNumberRegexValue = !regexAccountNumber.test(value);
            if (accountNumberRegexValue) {
              columnConfig[index].hasError = true;
              columnConfig[index].errMsg = `Enter a valid ${object.name}`;
            }
          } else if (validationConfig?.isMin && value.length < validationConfig?.minValue) {
            columnConfig[index].hasError = true;
            columnConfig[index].errMsg = !Utility.isEmpty(
              validationConfig?.minError
            ) ? validationConfig.minError : `Enter a valid ${object.name}`;
          } else if (validationConfig?.isMax && value.length > validationConfig?.maxValue) {
            columnConfig[index].hasError = true;
            columnConfig[index].errMsg = !Utility.isEmpty(
              validationConfig?.maxError
            )
              ? validationConfig.maxError
              : `Enter a valid ${object.name}`;
          } else {
            columnConfig[index].hasError = false;
            columnConfig[index].errMsg = `Enter a valid ${object.name}`;
          }
        } else if(columnConfig[index].required && Utility.isEmpty(value)) {
          columnConfig[index].hasError = true;
          columnConfig[index].errMsg = `Enter a valid ${object.name}`;
        } else {
          columnConfig[index].hasError = false;
          columnConfig[index].errMsg = `Enter a valid ${object.name}`;
         }
    }

    const updateColumConfigForPaymentMethod = (selectedOption) => {
        if (selectedOption && selectedOption.id === "cash") {
            const alteredConfig = [
              { columnCode: "accountType", required: false, uiVisible: false },
              { columnCode: "ifsc", uiVisible: false, required: false },
              { columnCode: "accountNumber", uiVisible: false, required: false },
              { columnCode: "routingNumber", required: false, uiVisible: false },
              { columnCode: "upiId", required: false, uiVisible: false },
              { columnCode: "bank", required: false, uiVisible: false },
            ];
            const updatedOptions = {
              accountType: [],
              ifsc: "",
              accountNumber: "",
              routingNumber: "",
              upiId: "",
              bank: ""
            };
            if (Utility.isEmpty(defaultValues["paymentMethod"])) {
              alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
            } else {
              alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
            }
            EmployeeListService.getAlteredConfigDetails(
              paymentInitials,
              alteredConfig,
              true,
              defaultValues,
              updatedOptions
            );
          } else if (selectedOption && selectedOption.id === "cheque") {
            const alteredConfig = [
              { columnCode: "accountType", required: false, uiVisible: false },
              {
                columnCode: "accountNumber",
                uiVisible: true,
                required: false,
                name: "Employee Bank Account Number",
              },
              { columnCode: "routingNumber", required: false, uiVisible: false },
              { columnCode: "upiId", required: false, uiVisible: false },
              { columnCode: "bank", required: false, uiVisible: false },
            ];
            const updatedOptions = {
              accountType: [],
              routingNumber: "",
              upiId: "",
              bank: "",
            };
            if (Utility.isEmpty(defaultValues["paymentMethod"])) {
              alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
            } else {
              alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
            }
            switch(country) {
              case "IN":
                alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible:false });
                updatedOptions["ifsc"] = "";
                break;
            }
            EmployeeListService.getAlteredConfigDetails(
              paymentInitials,
              alteredConfig,
              true,
              defaultValues,
              updatedOptions
            );
          } else if (selectedOption && selectedOption.id === "upi") {
            const alteredOptions = [
              { columnCode: "accountType", required: false, uiVisible: false },
              { columnCode: "ifsc", required: false, uiVisible: false },
              { columnCode: "accountNumber", uiVisible: false, required: false},
              { columnCode: "routingNumber", required: false, uiVisible: false },
              { columnCode: "upiId", required: true, uiVisible: true, name: "UPI ID"},
              { columnCode: "bank", required: false, uiVisible: false },
            ];
            const updatedOptions = {
              accountType: [],
              ifsc:"",
              accountNumber:"",
              routingNumber: "",
              bank: "",
            };
            if (Utility.isEmpty(defaultValues["paymentMethod"])) {
              alteredOptions.push({ columnCode: "paymentMethod", hasError: true });
            } else {
              alteredOptions.push({ columnCode: "paymentMethod", hasError: false });
            }
            EmployeeListService.getAlteredConfigDetails(
              paymentInitials,
              alteredOptions,
              true,
              defaultValues,
              updatedOptions
            );
          } else {
            const updatedOptions = {
              upiId:""
            };
            const alteredConfig = [
              { columnCode: "upiId", required: false,uiVisible: false,name: "UPI ID"}
            ];
            switch(country) {
              case COUNTRY.US:
                alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
                alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
                alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
                alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
                alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
                break;
              case COUNTRY.SG:
                alteredConfig.push({ columnCode: "accountType", required: false, uiVisible: false });
                alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
                alteredConfig.push({ columnCode: "routingNumber", required: true, uiVisible: true, name: "Branch Code" });
                alteredConfig.push({ columnCode: "bank", required: true, uiVisible: true });
                alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
                break;
              case COUNTRY.MY:
                alteredConfig.push({ columnCode: "accountType", required: false, uiVisible: false });
                alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
                alteredConfig.push({ columnCode: "routingNumber", required: true, uiVisible: true, name: "Branch Code" });
                alteredConfig.push({ columnCode: "bank", required: true, uiVisible: true });
                alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
                break;
              case COUNTRY.IN:
                alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
                alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Employee Bank Account Number" });
                alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
                alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
                alteredConfig.push({ columnCode: "ifsc", required: true, uiVisible: true, name: "IFSC Code" });
                break;
              default:
                alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
                alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
                alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
                alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
                alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
                break;
            }
            if (Utility.isEmpty(defaultValues["paymentMethod"])) {
              alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
            } else {
              alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
            }
            EmployeeListService.getAlteredConfigDetails(
              paymentInitials,
              alteredConfig,
              true,
              defaultValues,
              updatedOptions
            );
          }
    };

    const scrollToBottom = () => {
      setTimeout(() => {
        const holder = document.getElementById("dk-form-popup-window");
        if (holder) {
          holder.scrollTop = holder.offsetHeight;
        }
      }, 10);
    };

    const getDetailsFormFields = () => {
      return detailsFormfields.map((obj, index) => {
        return (
          <div
            className="column p-h-l web-width-50"
            
            key={obj.id}
          >
            <div className="parent-width pb-m"
             
            >
              {obj.type != "toggle" && (
                <DKInput
                  autoFocus={index === 0 && props.autoFocus === true}
                  className={obj.hasError ? "mb-xs" : ""}
                  icon={obj.icon}
                  title={`${obj.name}`}
                  placeholder={obj.name}
                  value={defaultValues[obj.id]}
                  options={obj.options}
                  type={obj.type}
                  hasError={obj.hasError}
                  errorMsg={obj.errorMsg}
                  labelClassName=" text-align-left "
                  onChange={(value) => {
                    onChange(value, index, obj, "CONTRACTOR_DETAILS");
                  }}
                  direction={obj.direction}
                  required={obj.required}
                  isDisabled={!obj.editable}
                  dateFormat={props.dateFormat}
                  readOnly={obj.readOnly}
                  canValidate={obj.hasError}
                  onClick={() => {
                    if (index === detailsFormfields.length - 1) {
                      scrollToBottom();
                    }
                  }}
                  errorMessage={obj.errMsg}
                  validator={(text) => { // Write a function to validation fields and return false if invalid with canValidate as true with errorMessage
                    // return validateDetailsFields(text, index, obj);
                  }}
                />
              )}
              {/* {obj.hasError && (
                <DKLabel
                  className="pl-s fs-s unselectable text-red mt-s"
                  style={{
                    whiteSpace: "nowrap",
                  }}
                  text={obj.errMsg}
                />
              )} */}
            </div>
          </div>
        );
      });
    };

    const getCompensationFormFields = () => {
      return compensationFormfields.map((obj, index) => {
        return (
          <div
            className="column p-h-l web-width-50"
            
            key={obj.id}
          >
            <div
              className="parent-width"
            >
              {obj.type != "toggle" && (
                <DKInput
                  autoFocus={index === 0 && props.autoFocus === true}
                  className={obj.hasError ? "mb-xs" : ""}
                  icon={obj.icon}
                  title={`${obj.name}`}
                  placeholder={obj.name}
                  value={defaultValues[obj.id]}
                  options={obj.options}
                  type={obj.type}
                  hasError={obj.hasError}
                  errorMsg={obj.errorMsg}
                  labelClassName=" text-align-left "
                  onChange={(value) => {
                    onChange(value, index, obj, "COMPENSATION_DETAILS");
                  }}
                  direction={obj.direction}
                  required={obj.required}
                  isDisabled={!obj.editable}
                  dateFormat={props.dateFormat}
                  readOnly={obj.readOnly}
                  canValidate={obj.hasError}
                  errorMessage={obj.errMsg}
                  onClick={() => {
                    if (index === contactFormfields.length - 1) {
                      scrollToBottom();
                    }
                  }}
                />
              )}
              {/* {obj.hasError && (
                <DKLabel
                  className="pl-s fs-s unselectable text-red mt-s"
                  style={{
                    whiteSpace: "nowrap",
                  }}
                  text={
                    obj.errMsg
                    //   getCapitalized(this.props.title)
                    //   (this.state.required === true ? " *" : "")
                  }
                />
              )} */}
            </div>
          </div>
        );
      });
    };

    const getPaymentFormFields = () => {
      return paymentFormfields.map((obj, index) => {
        return (
          <div
            className="column p-h-l mb-m web-width-50"
            
            key={obj.id}
          >
            <DKInput
              autoFocus={index === 0 && props.autoFocus === true}
              className={obj.hasError ? "mb-xs" : ""}
              icon={obj.icon}
              title={obj.name}
              placeholder={obj.name}
              value={defaultValues[obj.id]}
              formatter={(obj) => {
                /** How to render a selected option in case of object **/
                return obj.name;
              }}
              options={obj.options}
              type={obj.type}
              hasError={obj.hasError}
              errorMsg={obj.errorMsg}
              labelClassName=" text-align-left "
              onChange={(value) => {
                onChange(value, index, obj, "PAYMENT_DETAILS");
              }}
              direction={obj.direction}
              required={obj.required}
              isDisabled={!obj.editable}
              dateFormat={props.dateFormat}
              readOnly={obj.readOnly}
              // canValidate={obj.hasError}
              errorMessage={obj.errMsg}
              onClick={() => {
                if (index === contactFormfields.length - 1) {
                  scrollToBottom();
                }
              }}
              dropdownConfig={{
                className: "",
                style: {},
                allowSearch:
                  obj.options && obj.options.length > 6 ? true : false,
                searchableKey: "name",
                data: obj.options,
                renderer: (index, obj) => {
                  /** How to render value in Dropdown in case of object **/
                  return <DKLabel text={`${obj.name}`} />;
                },
                onSelect: (index, obj) => {
                  // onValueChange(obj, "Quarter");
                },
              }}
              canValidate={obj.hasError}
              validator={(value) => {
                return !obj.hasError;
              }}
            />
            {/* {obj.hasError && (
              <DKLabel
                className="pl-s fs-s unselectable text-red mt-r"
                text={
                  obj.errMsg
                  //   getCapitalized(this.props.title)
                  //   (this.state.required === true ? " *" : "")
                }
              />
            )} */}
          </div>
        );
      });
    };

    const navigateTo = () => {
        removeEmployeeDetails();
        if(!isContracor) {
          RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_LIST)
        }
    }

    const removeEmployeeDetails = async () => {
      try {
        await dispatch(deleteEmployeeDetails());
      } catch (err) {
        // removeLoader();
        console.error("Error removing Employee Details: ", err);
      }
    };

    const saveAndNavigate = () => {
      const isInvalid = highlightInvalidFields();
      if (isInvalid) {
        let defaults = deepClone(defaultValues);
        setDefaultValues(defaults);
        let errorInfo = "Please fill all the mandatory details";
        showToast(errorInfo, TOAST_TYPE.FAILURE);
        return;
      }
      const saveObj = getContractorSaveObject();
        saveContractor(saveObj);
    }

    const highlightInvalidFields = () => {
      let columns = [detailsFormfields, compensationFormfields, paymentFormfields];
      let isInvalid = false;
      for (let i = 0; i < columns.length; i++) {
        let columnConfig = columns[i];
        for (let item = 0; item < columnConfig?.length; item++) {
          let individualColumn = columnConfig[item];
          const params = defaultValues;
          if (
            individualColumn &&
            params &&
            ((individualColumn.required &&
              Utility.isEmpty(params[individualColumn.columnCode])) ||
              individualColumn.hasError)
          ) {
            individualColumn.hasError = true;
            isInvalid = true;
          }
        }
      }
      // return invalid;
      contactFormfields.forEach((field) => {
          const error = hasError(field, field.value);
          field.invalid = error.invalid;
          field.errorMsg = error.errorMsg;
          if (field.invalid) {
            isInvalid = true;
          }
        });
      return isInvalid;
    }

    const hasError = (field, value) => {
      let error = {
        invalid: false,
        errorMsg: null,
      };

      const validation = field.validation;

      if (validation && validation.length !== 0) {
        validation.forEach((validation) => {
          switch (validation[0]) {
            case "required":
              if (
                value === null ||
                value === undefined ||
                String(value).trim() === ""
              ) {
                error.invalid = true;
              }
              break;
            case "pattern":
              if (value && !new RegExp(validation[1]).test(value)) {
                error.invalid = true;
                error.errorMsg = "Invalid " + field.title;
              }
              break;
          }
        });
      }

      return error;
    };
    const saveContractor = (params) => {
      showLoader(
        isEdit
          ? "Updating Contractor...Please wait"
          : "Adding Contractor...Please wait"
      );
      (!isEdit
        ? Table.saveEmployee(params)
        : Table.updateEmployee(params)
      ).then(
        (res) => {
          let message = ""
          if (res && res.user) {
            message = `${
              isEdit ? "Contractor Updated" : "Contractor Added"
            } Successfully`;
            toastrMessageActions(message, TOAST_TYPE.SUCCESS);
          } else if (res && res.errors && res.errors.length > 0) {
            let errors = res.errors[0];
            message = "Some Unknown Error Occurred at Server.Please Try Again!";
            if (errors.message && !Utility.isEmpty(errors.message)) {
              message = errors.message;
            }
            toastrMessageActions(message, TOAST_TYPE.WARNING);
          } else {
            message = "Some Unknown Error Occurred at Server.Please Try Again!";
            toastrMessageActions(message, TOAST_TYPE.FAILURE);
          }
        },
        (err) => {
          toastrMessageActions("Some Unknown Error Occurred at Server.Please Try Again!",
            TOAST_TYPE.FAILURE);
        }
      );
    };

    const toastrMessageActions = (message, type) => {
      removeLoader();
      showToast(message, type);
      removeEmployeeDetails();
      if(!isContracor) {
        RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_LIST);
      }

    }

    const getContractorSaveObject = () => {
      let contractorValue = {};
      const address = {};
      contactFormfields.forEach((field) => {
        if (field.type === INPUT_TYPE.DROPDOWN) {
          address[field.id] = getSelectValue(field.value, field.options);
        } else {
          address[field.id] = field.value;
        }
      });
      contractorValue.employerIdentificationNumber = !Utility.isEmpty(
        defaultValues["employerIdentificationNumber"]
      )
        ? EmployeeListService.unFormatValue(
            defaultValues["employerIdentificationNumber"],
            "EIN"
          )
        : "";
      contractorValue.socialSecurityNumber = !Utility.isEmpty(
        defaultValues["socialSecurityNumber"]
      )
        ? EmployeeListService.unFormatValue(
            defaultValues["socialSecurityNumber"],
            "SSN"
          )
        : "";
      contractorValue["contractorType"] = defaultValues["contractorType"];
      if (defaultValues["contractorType"] === "INDIVIDUAL") {
        contractorValue.employerIdentificationNumber = "";
      } else if (defaultValues["contractorType"] === "BUSINESS") {
        contractorValue.socialSecurityNumber = "";
      }
      if (countryCode != COUNTRY_CODE.US) {
        contractorValue.employerIdentificationNumber = "";
        contractorValue.socialSecurityNumber = "";
      }
      contractorValue.address = address;
      contractorValue.type = "CONTRACTOR";
      if (isEdit && contractorDetails) {
        contractorValue.userId = userId;
      }
      contractorValue.compensationCurrency = TenantService.get(
        TENANT.CURRENCY_CODE
      );
      const accountTypes =
        countryCode === COUNTRY_CODE.US ? AccountTypesUS : AccountTypes;
      const paymentMethod = getSelectedIdFromObject(
        defaultValues.paymentMethod,
        "id"
      );
      contractorValue.paymentDetails = {
        paymentMethod: paymentMethod,
        accountType: getSelectedIdFromObject(
          defaultValues.accountType,
          "id"
        ),
        routingNumber:
          paymentMethod === "directDeposit" && defaultValues.routingNumber
            ? defaultValues.routingNumber.toString()
            : "",
        accountNumber:
          paymentMethod != "upi" && defaultValues.accountNumber
            ? defaultValues.accountNumber.toString()
            : "",
        bank: "",
        bankId: "",
        upi:
          paymentMethod === "upi" && defaultValues.upiId
            ? defaultValues.upiId.toString()
            : "",
        ifsc: defaultValues.ifsc ? defaultValues.ifsc.toString() : "",
      };
      if((getTenantCountryCode() === COUNTRY.SG || getTenantCountryCode() === COUNTRY.MY) && paymentMethod === "directDeposit") {
        contractorValue.paymentDetails["bank"] = EmployeeListService.getSelectedIdFromObject(defaultValues.bank, "key");
        contractorValue.paymentDetails["bankId"] = EmployeeListService.getSelectedIdFromObject(defaultValues.bank, "id");
        contractorValue.paymentDetails["accountType"] = EmployeeListService.getSelectedIdFromObject(defaultValues.bank, "id");
      }
      contractorValue["title"] = !Utility.isEmpty(defaultValues["title"])
        ? trimValue(defaultValues["title"])
        : "";
      contractorValue["firstName"] = !Utility.isEmpty(
        defaultValues["firstName"]
      )
        ? trimValue(defaultValues["firstName"])
        : "";
      contractorValue["middleName"] = !Utility.isEmpty(
        defaultValues["middleName"]
      )
        ? trimValue(defaultValues["middleName"])
        : "";
      contractorValue["displayName"] = !Utility.isEmpty(
        defaultValues["displayName"]
      )
        ? trimValue(defaultValues["displayName"])
        : "";
      contractorValue["lastName"] = !Utility.isEmpty(defaultValues["lastName"])
        ? trimValue(defaultValues["lastName"])
        : "";
      contractorValue["emailId"] = !Utility.isEmpty(defaultValues["emailId"])
        ? trimValue(defaultValues["emailId"])
        : "";
      contractorValue["compensationPeriod"] = !Utility.isEmpty(
        defaultValues["compensationPeriod"]
      )
        ? trimValue(defaultValues["compensationPeriod"])
        : "";
      contractorValue["compensation"] = !Utility.isEmpty(defaultValues["compensation"])
        ? trimValue(defaultValues["compensation"])
        : "";

      return contractorValue;
    }

    const getSelectValue = (v, o) => {
      let value = v;

      const index = o.findIndex((i) => i.label === v);
      if (index !== -1) {
        value = o[index].value;
      }

      return value;
    };


    return (
      <>
        <div className="parent-width">
          <div style={{ width: "100%" }}>
            <DKLabel
              text={isEdit ? `Edit Contractor `: `Add Contractor`}
              className="fw-m fs-xl mb-r p-h-m"
            />
            {detailsFormfields && (
              <div className="mt-m parent-width bg-white border-radius-s card-shadow">
                <div>
                  <DKLabel
                    text="Select Contractor Type"
                    className="fw-m fs-m mb-r pt-l p-h-l"
                  />
                  <div className="fs-m mb-r p-h-l">
                    <DKRadioButton
                      title="Individual"
                      className="p-v-l"
                      color="bg-app"
                      isSelected={
                        defaultValues["contractorType"] != "BUSINESS"
                          ? true
                          : false
                      }
                      onClick={() =>
                        onContractorTypeChange("INDIVIDUAL", "contractorType")
                      }
                    />
                    <DKRadioButton
                      title="Business"
                      isSelected={
                        defaultValues["contractorType"] === "BUSINESS"
                          ? true
                          : false
                      }
                      color="bg-app"
                      onClick={() =>
                        onContractorTypeChange("BUSINESS", "contractorType")
                      }
                    />
                  </div>
                </div>
                <DKLabel
                  text="Contractor Details"
                  className="fw-m fs-m mb-r pt-l p-h-l"
                />
                <DKLine className="bg-line-2" />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className=" parent-width mb-s p-v-l"
                >
                  {detailsFormfields && getDetailsFormFields()}
                </div>
              </div>
            )}
            {contactFormfields && (
              <div className="mt-m parent-width bg-white border-radius-s card-shadow">
                <DKLabel
                  text="Contact Details"
                  className="fw-m fs-m mb-r pt-l p-h-l"
                />
                <DKLine className="bg-line-2" />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className=" parent-width mb-s p-v-l"
                >
                  {contactFormfields && (
                    <Address
                      className="pb-s"
                      countryCode={countryCode}
                      addressFields={contactFormfields}
                      module={ADDRESS_MODULE.EMPLOYEE_DETAILS}
                      isReadOnly={!PermissionUtils.hasAccess(ADDRESS_MODULE.EMPLOYEE_DETAILS, [ACTION.CREATE, ACTION.EDIT])}
                      onChange={(contactFormfields) => {
                        setContactFormFields(contactFormfields);
                        forceUpdate();
                      }}
                    />
                  )}
                </div>
              </div>
            )}
            {compensationFormfields && (
              <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
                <DKLabel
                  text="Compensation Details"
                  className="fw-m fs-l mb-r pt-l p-h-l"
                />
                <DKLine className="bg-line-2" />
                <div>
                  <DKLabel
                    text="Wages Type"
                    className="fw-m fs-m mb-r pt-l p-h-l"
                  />
                  <div className="fs-m p-h-l row">
                    <DKRadioButton
                      title="Hourly Wages"
                      className="pr-l"
                      color="bg-app"
                      isSelected={
                        defaultValues["compensationPeriod"] != "fixed"
                          ? true
                          : false
                      }
                      onClick={() =>
                        onContractorTypeChange("hourly", "compensationPeriod")
                      }
                    />
                    <DKRadioButton
                      title="Fixed Amount"
                      isSelected={
                        defaultValues["compensationPeriod"] === "fixed"
                          ? true
                          : false
                      }
                      color="bg-app"
                      onClick={() =>
                        onContractorTypeChange("fixed", "compensationPeriod")
                      }
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className=" parent-width mb-s pt-m pb-l"
                >
                  {compensationFormfields && getCompensationFormFields()}
                </div>
              </div>
            )}
            {paymentFormfields && (
              <div className="mt-xl mb-xl parent-width bg-white border-radius-s card-shadow">
                <DKLabel
                  text="Payment Details"
                  className="fw-m fs-m mb-r pt-l p-h-l"
                />
                <DKLine className="bg-line-2" />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className=" parent-width mb-s p-v-s"
                >
                  {paymentFormfields && getPaymentFormFields()}
                </div>
              </div>
            )}
            <div className="row mb-l">
              {props.accessedBy === ADMIN &&
                <DKButton
                    title="Cancel"
                    className="border-m bg-gray1 mr-r"
                    onClick={() => navigateTo()}
                />
              }
              <DKButton
                title="Save"
                className="border-m bg-button text-white bg-app"
                onClick={() => saveAndNavigate()}
              />
            </div>
          </div>
        </div>
      </>
    );
}

export default AddContractor;